<template>
  <TableGradient
      icon-name="flask"
      :title="$t('tuevs.exams.listagem.titulo_pagina')"
      table-data
      :items="exams"
      :fields="fields"
      :loading="isLoading"
      :paginator="pagination"
      :text-empty="$t('tuevs.exams.listagem.table.empty')"
      route-new="tuevs.exams.create"
      :text-new="$t('tuevs.exams.listagem.novo')"
      @list="evt => $store.dispatch('tuevs/exams/listAll', evt)">
    <template v-slot:cell(component)="linha">
      {{ linha.item.component ? linha.item.component.name : null }}
    </template>
    <template v-slot:cell(method)="linha">
      {{ linha.item.method ? linha.item.method.name : null }}
    </template>
    <template v-slot:cell(scale)="linha">
      {{ linha.item.scale ? linha.item.scale.name : null }}
    </template>
    <template v-slot:cell(specimen)="linha">
      {{ linha.item.specimen ? linha.item.specimen.name : null }}
    </template>
    <template v-slot:cell(time)="linha">
      {{ linha.item.time ? linha.item.time.name : null }}
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.exams.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.exams.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.exams.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.exams.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/exams/isLoading',
      exams: 'tuevs/exams/all',
      pagination: 'tuevs/exams/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.exams.listagem.table.nome'), sortable: true},
        //{key: 'external_code', label: this.$t('tuevs.exams.listagem.table.codigo'), sortable: true},
        {key: 'component', label: this.$t('tuevs.exams.listagem.table.componente')},
        //{key: 'method', label: this.$t('tuevs.exams.listagem.table.metodo')},
        //{key: 'scale', label: this.$t('tuevs.exams.listagem.table.escala')},
        {key: 'specimen', label: this.$t('tuevs.exams.listagem.table.material')},
        //{key: 'time', label: this.$t('tuevs.exams.listagem.table.tempo')},
        {key: 'status', label: 'Status'},
        {key: 'id', label: this.$t('tuevs.exams.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/exams/listAll'
    ])
  },
  mounted() {
    this['tuevs/exams/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
